import TiclickTable from '@src/design-system/molecules/ticlick-table';
import { PageContainer } from '@src/shared/components/page-container';
import { PageTitle } from '@src/shared/components/page-title';
import { AnnouncementOverviewBreakdownCards } from '../../components/announcements-stats/announcement-overview-breakdown-cards';
import { AnnouncementOverviewStats } from '../../components/announcements-stats/announcement-overview-stats';
import { useAnnouncementsTable } from '../../hooks/use-announcements-table';

export function Announcements() {
  const { table, actionsTable } = useAnnouncementsTable();

  return (
    <PageContainer>
      <div className='flex items-center gap-2.5'>
        <PageTitle titles={['Announcements']} />
      </div>

      <AnnouncementOverviewStats />

      <AnnouncementOverviewBreakdownCards />

      <div className='p-4 rounded-lg border bg-white border-pale-border [&_td]:text-gray-900 [&_th]:text-gray-800 [&_th]:h-12 [&_th]:font-bold [&_th]:text-sm'>
        <TiclickTable
          table={table}
          actions={actionsTable}
        />
      </div>
    </PageContainer>
  );
}

export default Announcements;
